const qButtons = document.querySelectorAll('gp-product .quick-add .button');
qButtons.forEach(button => {
    button.addEventListener('click', (event) => {
        event.preventDefault();
    });
});

const loyaltyPopup = document.getElementById('honeypop-app');
const loyaltyPopupTrigger = document.querySelector('.ll_footer a[href="#essential-loyalty-trigger"]');

// Close popup when clicking outside
document.addEventListener('click', (event) => {
    const loyaltyPopupContent = document.querySelector('#honeypop-app > div');
    if (!loyaltyPopupContent) return;
    if (!loyaltyPopupContent.contains(event.target)) {
        loyaltyPopupTrigger.click();
    }
});
